/* hooks */
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
/* Components */
import {
    getAgencyListByName,
    getAgencyListByZip,
} from "../../../api/admin/funedataReq";
import {removeAccents} from "../../../helper/Cleaner";
import useAuth from "../../../hooks/useAuth";


export default function FormAgencyFetch({ zipcode, city }) {
    const { auth } = useAuth();
    const token = auth.token;
    const [ searchByZipcode, setSearchByZipcode ] = useState();
    const [ searchByCity, setSearchByCity ] = useState();
    const navigate = useNavigate();
    const creds = process.env.REACT_APP_FUNEDATA_CREDS;

    const apiCityListAllByZipcode = async (zipcode) => {
        let body = {
            creds: creds,
            keyword: zipcode
        }
        const response = await getAgencyListByZip(body, token);
        setSearchByZipcode(response);
    };
    const apiCityListAllByName = async (city) => {
        let body = {
            creds: creds,
            keyword: city
        }
        const response = await getAgencyListByName(body, token);
        setSearchByCity(response);
    };

    useEffect(() => {
        if (zipcode && city) {
            apiCityListAllByZipcode(zipcode);
            if (city.startsWith(" ")) {
                let cleanCity = city.slice(1)
                let cleanNoAccentCity = removeAccents(cleanCity).replace(/-/g, ' ');
                apiCityListAllByName(cleanNoAccentCity);
            }
            else {
                apiCityListAllByName(city);
            }
        }
    }, [ zipcode, city ]);

    const handleImport = (e,id) => {
        e.preventDefault()
        navigate(`/admin/agences/${id}/creer`);
    }

    return (
        <>
            <div className="dashboard">
                <h2>Recherche par ville</h2>
                <table>
                    <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Manager</th>
                            <th>Adresse</th>
                            <th>Code postal</th>
                            <th>Ville</th>
                            <th>Import</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            searchByCity?.map((agency, index) => (
                                <tr key={`${index}-${agency?.id}`}>
                                    <td>{agency?.name}</td>
                                    <td>{agency?.manager}</td>
                                    <td>{agency?.address}</td>
                                    <td>{agency?.zipcode}</td>
                                    <td>{agency?.city}</td>
                                    <td><a href={`/admin/agences/${agency?.id}/importer`} onClick={(e) => handleImport(e,agency?.id)}><i className="fa fa-download"></i></a></td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>

            </div>
            <div className="dashboard">
                <h2>Recherche par code postal</h2>
                <table>
                    <thead>
                    <tr>
                        <th>Nom</th>
                        <th>Manager</th>
                        <th>Adresse</th>
                        <th>Code postal</th>
                        <th>Ville</th>
                        <th>Import</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        searchByZipcode?.map((agency, index) => (
                            <tr key={`${index}-${agency?.id}`}>
                                <td>{agency?.name}</td>
                                <td>{agency?.manager}</td>
                                <td>{agency?.address}</td>
                                <td>{agency?.zipcode}</td>
                                <td>{agency?.city}</td>
                                <td><a href={`/admin/agences/${agency?.id}/importer`} onClick={(e) => handleImport(e,agency?.id)}><i className="fa fa-download"></i></a></td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>
        </>
    )
}
